import { useDocumentStorageContext } from 'framework/documentStorage';
import {
  DataGridLayout,
  DropDownFilter,
  Filters,
  FiltersLayout,
  List,
  ListHeader,
  ListPageLayout,
  SearchInput,
  TableBodyWithGrouping,
} from 'framework/list';
import UploadComplianceRegistryButton from '../shared/buttons/UploadComplianceRegistryButton';
import { BadgeField, BooleanField, VersionField } from 'framework/ui/field';
import ComplianceDocumentListActions from '../shared/buttons/actions/ComplianceDocumentListActions';
import { Typography } from '@mui/material';
import { DownloadFileLinkField } from 'domain/shared/artifact/field';
import { CountryDropdown } from 'framework/form';
import ComplianceDocumentStatusBadgeField from '../shared/fields/ComplianceDocumentStatusBadgeField';
import { ComplianceDocumentTargetAudienceField, ComplianceDocumentTypeField } from 'domain/shared/compliance';
import ComplianceDocumentTypeFilter from './filter/ComplianceDocumentTypeFilter';
import ComplianceAllEmployeesFilter from './filter/ComplianceAllEmployeesFilter';
import { ComplianceRegistryRow } from './ComplianceRegistryRow';
import { EmployeePositionFilter, OfficeFilterById, ContractTypeFilter } from 'domain/shared/employee';
import { AccountFilter } from 'domain/shared/account';
import { ProjectFilter } from 'domain/shared/newProject';

const ComplianceRegistryListPage = () => {
  const { searchDocuments } = useDocumentStorageContext();

  const filters = (
    <Filters>
      <FiltersLayout>
        <ComplianceDocumentTypeFilter source="complianceType" label="Type" />
        <ComplianceAllEmployeesFilter source="relatedEmployeeFilter.is_empty" label="All workers" />
        <OfficeFilterById source="relatedEmployeeFilter.officeId.in" label="Office" />
        <EmployeePositionFilter source="relatedEmployeeFilter.positionId.in" label="Position" />
        <ContractTypeFilter source="relatedEmployeeContractTypes" label="Contract type" />
        <DropDownFilter
          source="relatedEmployeeFilter.businessRegistrationCountry.in"
          label="Business registration country"
        >
          <CountryDropdown source="relatedEmployeeFilter.businessRegistrationCountry.in" />
        </DropDownFilter>
        <AccountFilter source="relatedEmployeeAccountIds" label="Account" />
        <ProjectFilter source="relatedEmployeeProjectIds" label="Project" isByLegacyId />
      </FiltersLayout>
    </Filters>
  );

  return (
    <List getDataMethod={searchDocuments}>
      <ListPageLayout
        filter={filters}
        search={<SearchInput label="compliance document" />}
        header={<ListHeader label="Compliance Registry" />}
        actions={[<UploadComplianceRegistryButton />]}
      >
        <DataGridLayout
          buttons={[<ComplianceDocumentListActions />]}
          tableBodyComponent={(props: any) => (
            <TableBodyWithGrouping
              {...props}
              childrenSource="metadata.previousVersions"
              toggleSource="space"
              CustomChildTemplate={<ComplianceRegistryRow />}
            />
          )}
        >
          {/* @ts-ignore template additional types */}
          <Typography source="space" label="" width="3%" />
          <DownloadFileLinkField width="24%" label="Name" showNameSource="metadata.complianceName" />
          <ComplianceDocumentTypeField width="17%" label="Type" source="metadata.complianceType" />
          <VersionField width="8%" source="metadata.version" label="Version" />
          <BadgeField
            source="metadata.status"
            label="Status"
            width="12%"
            badges={[<ComplianceDocumentStatusBadgeField source="metadata.status" />]}
          />

          <BooleanField source="metadata.isSignatureRequired" label="Signing" width="8%" />

          <ComplianceDocumentTargetAudienceField label="Target audience" width="28%" />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default ComplianceRegistryListPage;
